import { useState, useEffect } from 'react';

const Countdown = ({ targetTimestamp }) => {
    const targetDate = new Date(targetTimestamp * 1000); // Convert seconds to milliseconds

    const calculateTimeLeft = () => {
        const now = new Date();
        const difference = targetDate.getTime() - now.getTime();

        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            timeLeft = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    const [hasEnded, setHasEnded] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeLeft = calculateTimeLeft();
            setTimeLeft(newTimeLeft);

            if (
                newTimeLeft.days === 0 &&
                newTimeLeft.hours === 0 &&
                newTimeLeft.minutes === 0 &&
                newTimeLeft.seconds === 0
            ) {
                clearInterval(timer);
                setHasEnded(true);
            }
        }, 1000);

        // Cleanup the interval when the component unmounts
        return () => clearInterval(timer);
    }, [targetTimestamp]); // Re-run effect if targetTimestamp changes

    const formatTime = (time) => {
        return time < 10 ? `0${time}` : time;
    };

    if (hasEnded) {
        window.location.href = "/";
    }

    return (
        <div style={{ padding: '1rem 0rem' }}>
            <p className='sub-title'>Token Valid until: {targetDate.toLocaleString()}</p>
            {/* {timeLeft.days > 0 && <span>{timeLeft.days} Days </span>} */}
            {/* <span>{formatTime(timeLeft.hours)}:</span> */}
            <p className='sub-title'>{`Countdown: ${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)} `}</p>

        </div>
    );
};

export default Countdown;